if (!customElements.get('byte-roll-pricing')) {
    class ByteRollPricing extends HTMLElement {
      constructor() {
        super();
  
        this.boundHandleClick = this.handleClick.bind(this);
      }
  
      connectedCallback() {
        this.#cacheElements();
        this.#bindEvents();
      }
  
      disconnectedCallback() {
        this.#unbindEvents();
      }
  
      handleClick(event) {
        const row = event.target.closest('[data-roll-row]');
        if (!row) return;
  
        this.#selectRow(row);
        this.#copyCode(row);
      }
  
      #selectRow(selectedRow) {
        for (const row of this.rows) {
          const isSelected = row === selectedRow;
          row.classList.toggle('is-selected', isSelected);
          row.setAttribute('aria-pressed', String(isSelected));
        }
      }
  
      async #copyCode(row) {
        const code = row.dataset.copyCode;
        if (!code) return;
  
        try {
          if (navigator.clipboard) {
            await navigator.clipboard.writeText(code);
          }
          this.#showCopyStatus(code);
        } catch (error) {
          console.error(error);
        }
      }
  
      #showCopyStatus(code) {
        if (!this.copyStatus) return;
  
        this.copyStatus.textContent = `Copied "${code}" to clipboard`;
        this.copyStatus.classList.add('is-visible');
  
        clearTimeout(this.copyStatusTimeout);
        this.copyStatusTimeout = setTimeout(() => {
          this.copyStatus.classList.remove('is-visible');
        }, 2000);
      }
  
      #cacheElements() {
        this.rows = this.querySelectorAll('[data-roll-row]');
        this.copyStatus = this.querySelector('[data-copy-status]');
      }
  
      #bindEvents() {
        this.addEventListener('click', this.boundHandleClick);
      }
  
      #unbindEvents() {
        this.removeEventListener('click', this.boundHandleClick);
      }
    }
  
    customElements.define('byte-roll-pricing', ByteRollPricing);
  }